module.exports = __webpack_public_path__ + "static/media/05.031.821ba64a.webp";